module.exports = __webpack_public_path__ + "img/0009.ed84696b.jpg";